/*
 * LienzoMoments — barra pegada de la pagina de venta
 * ---------------------------------------------------------------------------
 * Hace dos cosas:
 *
 *   1. decidir cuando se ve la barra
 *   2. mantener el precio al dia cuando cambia la variante elegida
 *
 * El scroll al selector NO lo hace este archivo: el boton lleva
 * `data-lm-goto="#lm-selector"` y lo resuelve `lienzomoments-scroll.js`, que
 * ya es el manejador unico de todos los botones que devuelven al selector.
 *
 * CUANDO SE VE
 * Se ve cuando no se esta viendo ni la galeria ni el selector.
 *
 * El blueprint pedia solo lo primero: aparecer cuando el hero sale de la
 * pantalla. Se le anade la segunda condicion porque un boton que dice "elegir
 * mi cuadro" flotando encima del selector es ruido: tapa 70px de la caja de
 * compra para ofrecer ir justo donde ya estas. En escritorio la columna de
 * compra es `sticky` y acompana el scroll durante media pagina, asi que sin
 * esta condicion la barra saldria casi siempre solapada con ella.
 *
 * Dos observers y no uno con dos objetivos: cada uno guarda su propio estado
 * y la barra se recalcula con los dos. Un solo observer obligaria a mirar
 * `entry.target` en cada callback para saber cual de los dos hablo.
 *
 * `data-stuck` REPLICA EL ATRIBUTO DE HORIZON
 * `lienzomoments-whatsapp.js` sube el boton flotante cuando la barra esta
 * desplegada, y lo detecta mirando `data-stuck`. Se conserva el mismo nombre
 * de atributo y los mismos valores ('true' / 'false') que usaba la barra
 * nativa para no tener que cambiar el contrato entre los dos componentes. Lo
 * unico que cambia alli es el selector con el que encuentra la barra.
 */
(() => {
  'use strict';

  const init = () => {
    const bar = document.querySelector('[data-lm-sticky-bar]');
    if (!bar || bar.dataset.lmReady === 'true') return;
    bar.dataset.lmReady = 'true';

    /* --- Precio ---------------------------------------------------------- */

    const priceOut = bar.querySelector('[data-lm-sticky-price]');
    let prices = {};

    /*
     * El mapa lo escribe Liquid con el formato de moneda de la tienda ya
     * aplicado. Si el JSON viniera roto, `prices` se queda vacio y el precio
     * simplemente deja de actualizarse: la barra sigue llevando al selector,
     * que es lo que de verdad tiene que hacer.
     */
    const priceScript = document.querySelector('[data-lm-sticky-prices]');
    if (priceScript) {
      try {
        prices = JSON.parse(priceScript.textContent) || {};
      } catch {
        prices = {};
      }
    }

    /*
     * `isConnected` protege del editor: al recargar una seccion Horizon
     * sustituye el nodo, y el listener del nodo viejo seguiria vivo colgado
     * de `document` escribiendo en una barra que ya no esta en la pagina.
     */
    document.addEventListener('lm:variant', (event) => {
      if (!priceOut || !bar.isConnected) return;
      const formatted = prices[event.detail?.variantId];
      if (formatted) priceOut.textContent = formatted;
    });

    /* --- Visibilidad ----------------------------------------------------- */

    const gallery = document.querySelector('#lm-gallery');
    const selector = document.querySelector('#lm-selector');

    /*
     * Sin galeria ni selector no hay nada contra lo que medir. Se deja la
     * barra escondida en vez de mostrarla siempre: una barra que no sabe
     * donde esta el usuario es peor que ninguna.
     */
    if (!gallery && !selector) return;

    let galleryVisible = Boolean(gallery);
    let selectorVisible = false;

    const render = () => {
      const show = !galleryVisible && !selectorVisible;
      bar.dataset.stuck = show ? 'true' : 'false';
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    const watch = (element, assign) => {
      if (!element) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          assign(entry.isIntersecting);
          render();
        },
        /*
         * Un umbral de 0 y sin margen: basta con que asome un pixel para que
         * cuente como visible. Con un umbral mayor la barra parpadearia justo
         * en el borde entre la galeria y la caja de compra, que es por donde
         * mas se pasa.
         */
        { threshold: 0 }
      );
      observer.observe(element);
    };

    watch(gallery, (visible) => {
      galleryVisible = visible;
    });
    watch(selector, (visible) => {
      selectorVisible = visible;
    });

    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon reemplaza secciones enteras al editar en el theme editor.
  document.addEventListener('shopify:section:load', init);
})();
